<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<div class="fulldiv img">

  <mat-card class="formWidthResetpwd" *ngIf="sendOTP">

    <mat-card-title class="text-center">Password Reset</mat-card-title>
    <mat-card-content>
      <form class="formWidthNew" novalidate [formGroup]="resetOTPForm"
        (submit)="resetOTPForm.valid && sendUserOTP(resetOTPForm.value)">
        <mat-form-field class="col w-84pct">

          <input matInput type="tel" placeholder="Enter Staff ID" formControlName="staffId" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))">

        </mat-form-field>
        <!-- No .bg-3493D8 and no .col here, deliberately:
             .bg-3493D8 forced a one-off #3493D8 blue (with !important) that
             overrode the theme primary set by `p button` in this component's
             SCSS. .col is a Bootstrap grid column and carries width:100%, which
             stretched the button across the whole card.
             Without them the button uses the primary #3f51b5 and sizes to its
             own text; .text-center on the wrapper keeps it centred. -->
        <p class="flex-none buttonWidth text-center">
          <button class="border-none"
            [disabled]="!resetOTPForm.valid">SUBMIT</button>
        </p>
      </form>
    </mat-card-content>

  </mat-card>

  <mat-card class="formWidthResetpwd" *ngIf="verifyOTP">
    <mat-card-title class="text-center">Verify OTP</mat-card-title>
    <p *ngIf="resendNotice" class="otpStyle p-6px-custom bg-aliceblue">OTP sent to
      your mobile number</p>
    <mat-card-content>
      <form class="formWidthNew" novalidate [formGroup]="verifyOTPForm"
        (submit)="verifyOTPForm.valid && verifyUserOTP(verifyOTPForm.value)">
        <mat-form-field class="col w-full">

          <input matInput type="OTP" maxlength="4" placeholder="OTP" formControlName="otp">

        </mat-form-field>
        <a class="cursor-pointer" (click)="resendOTP()">Resent OTP</a>
        <!-- No .bg-3493D8 and no .col here, deliberately:
             .bg-3493D8 forced a one-off #3493D8 blue (with !important) that
             overrode the theme primary set by `p button` in this component's
             SCSS. .col is a Bootstrap grid column and carries width:100%, which
             stretched the button across the whole card.
             Without them the button uses the primary #3f51b5 and sizes to its
             own text; .text-center on the wrapper keeps it centred. -->
        <p class="flex-none buttonWidth text-center">
          <button class="border-none"
            [disabled]="!verifyOTPForm.valid">VERIFY</button>
        </p>
      </form>
    </mat-card-content>

  </mat-card>


  <mat-card class="formWidthResetpwd" *ngIf="changePassword">
    <mat-card-title class="text-center">Password Reset</mat-card-title>
    <mat-card-content>
      <form class="formWidthNew" novalidate [formGroup]="updatePasswordForm"
        (submit)="updatePasswordForm.valid && resetPassword(updatePasswordForm.value)">

        <mat-form-field class="col w-full">

          <input matInput type="password" placeholder="Enter new password" formControlName="changePassword" autocomplete="off">
          <mat-error *ngIf="updatePasswordForm.get('changePassword').hasError('required')">Password is required </mat-error>
          <mat-error *ngIf="updatePasswordForm.get('changePassword').hasError('pattern')">
            Password must be 8-24 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character. Spaces are not allowed.
          </mat-error>

        </mat-form-field>
        <mat-form-field class="col w-full">

          <input matInput type="password" placeholder="Re-enter password" formControlName="confirmPassword" autocomplete="off">

        </mat-form-field>

        <!-- No .bg-3493D8 and no .col here, deliberately:
             .bg-3493D8 forced a one-off #3493D8 blue (with !important) that
             overrode the theme primary set by `p button` in this component's
             SCSS. .col is a Bootstrap grid column and carries width:100%, which
             stretched the button across the whole card.
             Without them the button uses the primary #3f51b5 and sizes to its
             own text; .text-center on the wrapper keeps it centred. -->
        <p class="flex-none buttonWidth text-center">
          <button class="border-none"
            [disabled]="!updatePasswordForm.valid">SUBMIT</button>
        </p>
      </form>
    </mat-card-content>

  </mat-card>


</div>